function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M99.4 155.8c-.2-19.6-16.2-35.4-35.9-35.4H42.7v-28H14.2v141.8h28.5V213h198.1v21.2h28.5v-78.3l-169.9-.1zm-35.8-21c11.6 0 21.1 9.3 21.3 20.9H42.7v-20.9h20.9zm-20.9 35.5h212.1v14.1H42.7v-14.1z"
})));